import { Component, Inject, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from "../../../../../environments/environment";
import { UserService } from 'src/app/providers/user.service';
import { AuthService } from 'src/app/providers/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/providers/common.service';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { Users } from 'src/app/core/model/user';
import { MessageService } from 'primeng/api';
import { DOCUMENT } from '@angular/common';
import { isEmpty } from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TermsAndconditionComponent } from '../../terms-condition/terms-condition.component';
import { TotpAuthRoutingService } from 'src/app/providers/totp-auth-routing.service';
import { TotpFlowSessionService } from 'src/app/providers/totp-flow-session.service';

@Component({
  selector: 'app-multi-factor-auth',
  templateUrl: './multi-factor-auth.component.html',
  styleUrls: ['./multi-factor-auth.component.scss']
})
export class MultiFactorAuthComponent implements OnInit {

  @Input() widthClass = 'col-md-10 col-xl-6';
  @Input() native = 'auth';
  @Output() afterSuccessVerifyOtp = new EventEmitter<any>();
  @Output() onError = new EventEmitter<any>();
  @Output() onBack = new EventEmitter<any>();
  @Output() enrollmentEmailVerified = new EventEmitter<any>();
  @Input() title = "Hello there,";
  @Input() content = "Multi Factor Authentication (MFA) keeps your account safe from password hacks.";
  @Input() mfaData:any = {};
  @Input() apiName='';
  @Input() httpOptions={};
  @Input() formData={};
  @Input() showBackButton=false;
  @Input() isFullWidth=false;
  @Input() embedded=false;
  @Input() hideTermsCheck=false;
  loginLogo:any
  tagName:any
  imageUrl = environment.whitelabelLogoPath;
  termsAllowUsers : any
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    public commonService: CommonService,
    private messageService: MessageService,private  modalService: NgbModal,
    private totpAuthRouting: TotpAuthRoutingService,
    private totpFlow: TotpFlowSessionService,
    @Inject(DOCUMENT) private document: Document
  ) { }
  environmentData = environment;
  mfaForm: FormGroup = this.fb.group({
    otp: [null, [Validators.required, Validators.maxLength(6)]],
    agreed: [false]
  })
  checkAgreed: boolean = false;
  loaders = {
    logging: false,
    timer: false
  }
  TIMER = 60
  timer = this.TIMER
  intervalId
  user: Users
  returnUrl = "/"
  resendOTPApiName;
  resendOTPPayload={};
  userId: any | null = null;
  showTermsModal = false;
  showTermsCheck = false;
  showBrandClass = true

  ngOnInit(): void {
    let whitelabelResData = JSON.parse(localStorage.getItem('whitelabelResData'));
    this.termsAllowUsers = JSON.parse(localStorage.getItem('terms_allow_user') || 'null');
    if (!isEmpty(whitelabelResData)) {
      this.loginLogo = `${this.imageUrl}/${whitelabelResData.logo_Login}`
      this.tagName = whitelabelResData.tagName
      whitelabelResData.logo_dashboard = `${this.imageUrl}/${whitelabelResData.logo_dashboard}`
      this.showBrandClass = false

    }
    this.mfaForm.get('agreed')?.valueChanges.subscribe((value) => {
      this.checkAgreed = value;
    });
    if (this.native == 'auth') {
      this.user = this.authService.getUser;
      // Embedded in TOTP setup: parent already applied user theme — do not
      // overwrite with stale localStorage.defaultTheme (falls back to purple).
      if (!this.embedded) {
        this.authService.defaultTheme();
        const themeColor =
          this.user?.themeColor
          || localStorage.getItem('defaultTheme')
          || 'theme-purple-light';
        this.document.body.classList.remove(
          'theme-cyan-light',
          'theme-bluegrey-light',
          'theme-purple-light',
        );
        this.document.body.classList.add(themeColor);
      }
      this.apiName = apiLinks.mfa.verifyOTP;
      if (!(this.user?.id && this.user?.email)) {
        this.router.navigate(['/auth/login'])
      } else {
        this.mfaData = {
          email: this.user.email,
          id: this.user?.id,
          whitelabelData: (whitelabelResData?.domainName == environment?.portalUrl || whitelabelResData?.domainName == 'https://ipospays.tech') ? null : whitelabelResData
        };
        this.resendOTPApiName = apiLinks.mfa.resendOTP;
        this.resendOTPPayload = this.mfaData;
      }

    }else{
      if (!this.mfaData?.uiRefId) {
        this.onError.next({message:"Invalid Request !"});
      }
      this.resendOTPApiName = apiLinks.mfa.resendOTPWithUiRefId;
      this.resendOTPPayload = {
        uiRefId:this.mfaData?.uiRefId,
        whitelabelData: (whitelabelResData?.domainName == environment?.portalUrl || whitelabelResData?.domainName == 'https://ipospays.tech') ? null : whitelabelResData
      };
    }

    const psi = localStorage.getItem("psi")

    this.addScriptElement(psi)
    if (this.hideTermsCheck) {
      this.showTermsCheck = false;
    } else if (!this.termsAllowUsers?.length) {
      this.showTermsCheck = false;
    } else {
      this.showTermsCheck = this.termsAllowUsers.includes(this.user?.userType) && !this.user?.isTermsCheck;
    }
  }

  setTimer = () => {
    this.intervalId = setInterval(() => {
      if ( this.timer > 0) {
        this.timer = this.timer - 1
      }
    }, 1000)
  }

  async onResendCode() {
    this.loaders.timer = !this.loaders.timer
    if (!this.mfaData?.id && !this.mfaData?.uiRefId) {
      return
    }
    try {

      this.setTimer()
      const resendCodeRes = await this.commonService.postCommonHttpClient(this.resendOTPApiName, this.resendOTPPayload).toPromise()
      const { message } = resendCodeRes;
      if (resendCodeRes?.toaster_type == 'MODAL' && message) {
        this.authService.showModal({ message , ...resendCodeRes });
      } else {
        this.showSuccessToast(message)

      }

      setTimeout(() => {
        clearInterval(this.intervalId)
        this.loaders.timer = !this.loaders.timer
        this.timer = this.TIMER
      }, (this.TIMER  - 1) * 1000);

    }
    catch (err) {
      clearInterval(this.intervalId)
      this.loaders.timer = false
      // shoe notifications
      this.messageService.clear();
      if (err.type == 'MODAL') {
        this.authService.showModal(err );
      } else {
        this.showErrorToast(err.message)
      }
    }
  }

  async onCancel() {
    if (this.native == 'auth') {
      // TOTP enroll embeds MFA — parent handles silent login replace
      if (this.embedded) {
        this.onBack.emit(true);
        return;
      }
      window.open("/auth/login", "_self")
      localStorage.removeItem("current_user");
      return;
    }
    this.onBack.next(true)
  }

  async onVerifyOtp(data) {
    const { otp } = this.mfaForm.value
    const agreed = this.checkAgreed;

    if (!otp) return
    if (this.showTermsCheck && !agreed) return;

    this.loaders.logging = true
    try {
      const verifyOtp = await this.commonService.postCommonHttpClient(
        this.apiName, {
        ...(this.native == 'auth'?this.mfaData:this.formData),
        otp,isTermsCheck : this.checkAgreed,UserRoleType:this.user?.userType

      },this.httpOptions).toPromise()
      this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";

      if (this.native == "auth") {

        if (verifyOtp?.emailOtpVerified && verifyOtp?.totpEnrollmentPending) {
          this.loaders.logging = false;
          this.messageService.clear();
          this.authService.setUser({
            ...this.authService.getUser,
            totpEnrollmentPending: true,
            totpSetup: verifyOtp?.totpSetup,
          });
          this.enrollmentEmailVerified.emit(verifyOtp);
          return;
        }

        if (verifyOtp?.accessToken) {
            this.authService.setUser(verifyOtp);
          localStorage.setItem("logger_token", "multiLogin");
    
            //ISV users should be redirected to user-management/users page
            if (verifyOtp?.userType === 'ISV') {
              this.router.navigateByUrl('/user-management/users');
              return;
            }

            if (verifyOtp?.userType == 'MULTI_STORE_MANAGER') {
              this.navigateToReturnUrl(this.route.snapshot.queryParams["returnUrl"] || '/user-management/users');
            } else {
              const excludeFeatures = verifyOtp && verifyOtp.excludeFeatures || [];
              if(excludeFeatures.indexOf('VIEW_DASHBOARD') > -1){
                const { roleFeatures } = verifyOtp;
                const featureExists = (module, feature) => roleFeatures.some(item => item.module === module && item.features.includes(feature));
                this.router.navigateByUrl(
                  featureExists("CLOUD_POS", "PAYMENTS")
                    ? '/virtual-terminal/list'
                    : featureExists("TRANSACTION", "VIEW_TRANSACTION")
                      ? '/transaction-management/transactions'
                      : '/user-management/users'
                );
              }else{
                this.navigateToReturnUrl(this.returnUrl);
              }
            }
        }
        else {
          this.loaders.logging = false;
          this.messageService.clear();
          this.showErrorToast("Something Happened , Please try again later!")
        }

      } else {

        this.afterSuccessVerifyOtp.next(verifyOtp);
        
      }

    }

    catch (err) {   
      console.log(err);
         
      this.messageService.clear();
      if (err.type == 'MODAL') {
        const modalRef = this.authService.showModal(err);
        if (this.totpAuthRouting.shouldNavigateToLoginAfterError(err)) {
          Promise.resolve(modalRef?.result).then(
            () => this.goToLoginAfterUnrecoverableError(),
            () => this.goToLoginAfterUnrecoverableError(),
          );
        }
      } else {
        this.showErrorToast(err.message)
      }
      this.loaders.logging = false

    }
  }

  private goToLoginAfterUnrecoverableError(): void {
    this.totpAuthRouting.returnToLoginAfterAbandon();
  }

  showErrorToast(detail: string) {
    this.messageService.clear();
    const toast: Record<string, unknown> = {
      severity: 'error',
      summary: 'Error',
      detail,
      sticky: true,
    };
    if (!this.embedded) {
      toast.key = 'mfa-toast';
    }
    this.messageService.add(toast as any);
  }

  showSuccessToast(detail: string) {
    this.messageService.clear();
    const toast: Record<string, unknown> = {
      severity: 'success',
      summary: 'Success',
      detail,
      life: 7000,
    };
    if (!this.embedded) {
      toast.key = 'mfa-toast';
    }
    this.messageService.add(toast as any);
  }

  addScriptElement(psiUrl: string) {

    if ( !psiUrl) return
    const node = document.createElement('script');
    node.id = "mem-id";// creates the script tag
    node.src = psiUrl; // sets the source (insert url in between quotes)
    node.type = "text/javascript"  // set the script type
    node.async = true; // makes script run asynchronously
    node.defer = true; // prevents script from blocking HTML parsing
    node.referrerPolicy = "strict-origin-when-cross-origin"; // limits how much referrer information is sent to Memyco servers
    // append to head of document
    document.getElementsByTagName('head')[0].appendChild(node);

    const mem = document.getElementById("mem-id")
    console.log("mem added")
  }

  ngOnDestroy() {
    const mem = document.getElementById("mem-id")
    if (mem) {
      mem.remove()
    }
    console.log("mem removed:", mem)
  }

  openTermsModal(event: Event): void {
    event.preventDefault();
    const fileUrl = apiLinks?.loadTermsPdf
    sessionStorage.setItem('termsPdfUrl', fileUrl);
    window.open(`/terms-condition`, '_blank');
  }

  /**
   * Navigates to returnUrl. If it is an absolute URL (e.g. VMS at localhost:4300),
   * performs a full page redirect via window.location; otherwise uses Angular router.
   */
  private navigateToReturnUrl(url: string): void {
    if (url && (url.startsWith('http://') || url.startsWith('https://'))) {
      window.location.href = url;
    } else {
      this.router.navigateByUrl(url || '/');
    }
  }

}